/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Sprint weekends add an extra sprint session alongside qualifying and the race, and Fantasy Points breaks it out separately so you can see exactly what the sprint contributed. Sprint scoring uses lower point values than the main race, which is why a strong sprint alone rarely matches a good race result.`)
};

const es_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Los fines de semana de sprint añaden una sesión de sprint adicional junto a la clasificación y la carrera, y Fantasy Points la desglosa por separado para que veas exactamente lo que aportó el sprint. La puntuación del sprint usa valores más bajos que la carrera principal, por lo que un buen sprint por sí solo rara vez iguala un buen resultado en carrera.`)
};

const de_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Sprint-Wochenenden fügen neben Qualifying und Rennen eine zusätzliche Sprint-Session hinzu, und Fantasy Points weist sie separat aus, sodass du genau siehst, was der Sprint beigetragen hat. Die Sprint-Wertung verwendet niedrigere Punktwerte als das Hauptrennen — deshalb kann ein starker Sprint allein selten ein gutes Rennergebnis aufwiegen.`)
};

const nl_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Sprintweekenden voegen een extra sprintsessie toe naast de kwalificatie en de race, en Fantasy Points splitst die apart uit zodat je precies ziet wat de sprint heeft bijgedragen. Sprintscoring gebruikt lagere puntwaarden dan de hoofdrace, waardoor een sterke sprint alleen zelden opweegt tegen een goed raceresultaat.`)
};

const fr_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les week-ends de sprint ajoutent une session de sprint supplémentaire en plus de la qualification et de la course, et Fantasy Points la détaille séparément pour que vous voyiez exactement ce que le sprint a apporté. La notation du sprint utilise des valeurs de points plus faibles que la course principale, ce qui explique pourquoi un bon sprint seul égale rarement un bon résultat en course.`)
};

const it_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. I weekend sprint aggiungono una sessione sprint in più oltre a qualifica e gara, e Fantasy Points la mostra separatamente così vedi esattamente quanto ha contribuito lo sprint. Il punteggio sprint usa valori più bassi rispetto alla gara principale, motivo per cui un ottimo sprint da solo raramente eguaglia un buon risultato in gara.`)
};

const pt_br2_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Fins de semana de sprint adicionam uma sessão de sprint extra além da classificação e da corrida, e o Fantasy Points mostra isso separadamente para você ver exatamente o que o sprint contribuiu. A pontuação do sprint usa valores mais baixos do que a corrida principal, por isso um bom sprint sozinho raramente compensa um resultado fraco na corrida.`)
};

const pt_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os fins de semana de sprint acrescentam uma sessão de sprint extra além da qualificação e da corrida, e o Fantasy Points destaca-a separadamente para que veja exatamente o que o sprint contribuiu. A pontuação do sprint usa valores mais baixos do que a corrida principal, por isso um bom sprint isoladamente raramente iguala um bom resultado em corrida.`)
};

const ja_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。スプリント週末には予選とレースに加えて追加のスプリントセッションがあり、Fantasy Pointsではそれを分けて表示するので、スプリントが具体的にどれだけ貢献したかが分かります。スプリントのスコアリングは本戦レースよりも低いポイント値を使用するため、スプリントだけで好成績を収めても、良いレース結果には及ばないことがほとんどです。`)
};

const zh_f1_fp_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。冲刺赛周末在排位赛和正赛之外还会增加一个冲刺赛环节，Fantasy Points会单独列出，让你清楚看到冲刺赛具体贡献了多少积分。冲刺赛计分使用的积分值低于正赛，因此仅凭出色的冲刺赛表现，很难抵得上一个出色的正赛结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_fp_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_fp_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_fp_faq4_a", locale)
	if (locale === "en") return en_f1_fp_faq4_a(inputs)
	if (locale === "es") return es_f1_fp_faq4_a(inputs)
	if (locale === "de") return de_f1_fp_faq4_a(inputs)
	if (locale === "nl") return nl_f1_fp_faq4_a(inputs)
	if (locale === "fr") return fr_f1_fp_faq4_a(inputs)
	if (locale === "it") return it_f1_fp_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_fp_faq4_a(inputs)
	if (locale === "pt") return pt_f1_fp_faq4_a(inputs)
	if (locale === "ja") return ja_f1_fp_faq4_a(inputs)
	return zh_f1_fp_faq4_a(inputs)
};